<template>
  <WorkBenchSequenceWaggonAdd height="calc(100% - 350px - 48px)">
    <template #activator>
      <Activator
        key="nowaggonsactivtor"
        class="self-centered cursor-s-resize"
        @click.native="
          $router.push({
            name: `${location}SequenceEditor`
          })
          "
      />
    </template>
    <template #content>
      <StandardFlexBox
        width="calc(100%)"
        height="calc(100% - 8px)"
        class="mt-1 mb-1 pa-1"
        style="border-left: solid 1px white"
        direction="column"
        >
        <!-- WORK PACKAGES NAV BAR / SEARCH / FILTER START -->
        <StandardFlexBox height="28px">
          <template v-if="workbench_variables.search === ''">
            <TText
              :value="$store.state.WorkBench.all_loaded.includes(`workpackages`) ? 'All' : 'Last Updated'"
            />
          </template>
          <template v-else>
            <TText
              :value="'Search result{symbol} {searchVal}'"
              :value_props="{symbol: ':', searchVal: workbench_variables.search}"
            />
          </template>
          <v-progress-circular v-if="$store.state.WorkBenchLocal.workbench_variables.loading" class="ml-2" :width="2" :size="20" indeterminate color="primary"></v-progress-circular>
          <v-spacer/>
            <TSearchField
            height="23px"
            width="20%"
            style="margin:auto"
            color="#757575"
            border_color="rgb(41,41,41)"
            placeholder="Search for wagons"
              :value="workbench_variables.search"
            @input="workbenchSearch($event.target.value)"
            @cancel="updateWBLObject({
              path: [
              {workbench_variables: ''}
              ],
              update: {
                search: ''
              }
              })"
              />
          <v-btn
          class="ml-1"
          small
          @click="loadData(''), addLoadAll(`${prefix_wp_seletion}workpackages`)">
            Load all
          </v-btn>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
               class="ml-5"
               small
               disabled
               v-on="on"
               v-bind="attrs"
               @click="switchWorkpackageType('')"
               :class="prefix_wp_seletion == ''?'grey':''"
               >
               <v-icon small>person</v-icon>
               </v-btn>
            </template>
            <span>{{$t('WorkBench.Editor.Waggon.TooltipOwn')}}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
               small
               disabled
               v-on="on"
               v-bind="attrs"
               @click="switchWorkpackageType('b')"
               :class="prefix_wp_seletion == 'b'?'grey':''"
               >
               <v-icon small>work</v-icon>
               </v-btn>
            </template>
            <span>{{$t('WorkBench.Editor.Waggon.TooltipBusiness')}}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
               small
               disabled
               v-on="on"
               v-bind="attrs"
               @click="switchWorkpackageType('c')"
               :class="prefix_wp_seletion == 'c'?'grey':''"
               >
               <v-icon small>people</v-icon>
               </v-btn>
            </template>
            <span>{{$t('WorkBench.Editor.Waggon.TooltipCommunity')}}</span>
          </v-tooltip>
          <v-btn
            class="ml-5"
            small
            disabled
            @click="$router.push({
                name: `${location}SequenceWaggonAddCreateTemplate`
              })"
            >
            create
          </v-btn>
        </StandardFlexBox>
        <!-- WAGONS NAV BAR / SEARCH / FILTER END -->
        <!-- WAGONS LIST START -->
        <StandardFlexBox
          width="100%"
          height="calc(100% - 28px)"
          >
        <StandardFlexBox
          width="100%"
          height="calc(100% - 28px)"
          >
          <!-- Settings:
          {{ sequence_index }}
          {{ add_before }} -->
        </StandardFlexBox>
          <Waggon
            @click.native="createWaggon('', [])"
            :workpackage_count="0"
            :zoom="2"
            style="cursor: pointer;"
          >
            <template #content>
              <div class="token-view" style="font-size: large;">
                empty
              </div>
            </template>
          </Waggon>
          <StandardDataField
            placeholder="Amount of empty wagons"
            width="25%"
            height="26px"
            text_color="white"
            :value="amount_of_waggons"
            @changeValue="amount_of_waggons = $event;"
          />
          <!-- <v-btn class="ml-5" small @click="createWaggon()">add</v-btn> -->
        </StandardFlexBox>
        <StandardFlexBox
          width="100%"
          height="calc(100% - 28px)"
          >
          <Waggon
            v-for="waggon in getWBObjectsFiltered({
              type: `${prefix}waggons`,
              search: {
                token: workbench_variables.search,
                hashtag: workbench_variables.search,
              },
              /* workbench: location === 'WorkBench'?true:false, */
            })"
            :key="`${prefix}${waggon.id}`"
            :workpackage_count="waggon[`${prefix}wagworkpackages`].length"
            :zoom="2"
            @click.native="createWaggon(waggon.token || '', translateWorkPackages(waggon[`${prefix}wagworkpackages`]))"
            >
            <template #content>
              <div class="token-view" style="font-size: large;">
                {{waggon.token?waggon.token:''}}
              </div>
              <Workpackage
                v-for="(workpackage) in getWBObjects({type: `${prefix}wagworkpackages`, ids: waggon[`${prefix}wagworkpackages`]})"
                :key="`wagworkpackage${workpackage.id}`"
                :workpackage_count="waggon[`${prefix}wagworkpackages`].length"
                :workpackage="workpackage"
                :zoom="2"
                />
            </template>
          </Waggon>
        </StandardFlexBox>
        <!-- WORK PACKAGES LIST END -->
      </StandardFlexBox>
    </template>
  </WorkBenchSequenceWaggonAdd>
</template>
<script>
  // import store from '@/store/index';
  import { WorkBenchSequenceMixin } from '@/mixins/WorkBenchSequence.mixin.js';
  export default {
    props: ['prefix','sequence_id','read_only', 'create', 'sequence_index', 'add_before', 'location'],
    mixins: [
      WorkBenchSequenceMixin,
    ],
    data: () => ({
      amount_of_waggons: 1
    }),
    beforeRouteLeave(to, from, next){
      this.updateWBLObject({
          path: [
            {workbench_variables: ''}
          ],
          update: {
            search: ''
          }
        });
        next();
    },
    created() {
      // this.ai_animation_recommendation = true;
      this.loadData(`&limit=8&offset=0`);
    },
    watch: {
      prefix() {
        this.loadData(`&limit=8&offset=0`);
      }
    },
    methods: {
      createWaggon(token, sworkpackages = null){

        let mod;
        if ( this.add_before ) {
          mod = 0;
        } else {
          mod = 1;
        }

        let wb_object = {
          position: this.sequence_index + 1 + mod,
          token: token
        };

        if (sworkpackages !== null) {
          wb_object.sworkpackages = sworkpackages;
        }

        if (this.create) {
          // delete wb_object.position;
          for (let i = 0; i < this.amount_of_waggons; i++) {
            wb_object.position += i;
            this.createWBLObject({
              path: [
                {sequence: ''},
                {swaggons: ''}
              ],
              wbl_object: JSON.parse(JSON.stringify(wb_object))
            });
          }
        } else {
          // BULK only for empty waggons
          if ( (sworkpackages === null || sworkpackages.length === 0) && parseInt(this.amount_of_waggons) > 1 ) {
            wb_object['bulk'] = parseInt(this.amount_of_waggons);
          }
          this.createWBObject({
            url: [
              {[`${this.prefix}sequences`]: this.sequence_id},
              {[`${this.prefix}swaggons`]: ''},
              {showWithEntitiesNormalized: ''}
            ],
            wb_object: wb_object
          });
        }
      },
      translateWorkPackages(workpackages){
        let sworkpackages = [];
        for (var i = 0; i < workpackages.length; i++) {
          let swp = this.getWBObject({ type: `${this.prefix}wagworkpackages`, id: workpackages[i]});
          swp.sworksteps = this.getWBObjects({ type: `${this.prefix}wagworksteps`, ids: swp.wagworksteps});
          swp.squalitysteps = this.getWBObjects({ type: `${this.prefix}wagqualitysteps`, ids: swp.wagqualitysteps});
          swp.slogisticsteps = this.getWBObjects({ type: `${this.prefix}waglogisticsteps`, ids: swp.waglogisticsteps});
          swp.sdefectsteps = this.getWBObjects({ type: `${this.prefix}wagdefectsteps`, ids: swp.wagdefectsteps});
          swp.sdesignsteps = this.getWBObjects({ type: `${this.prefix}wagdesignsteps`, ids: swp.wagdesignsteps});
          swp.smaterialsteps = this.getWBObjects({ type: `${this.prefix}wagmaterialsteps`, ids: swp.wagmaterialsteps});
          swp.smachinesteps = this.getWBObjects({ type: `${this.prefix}wagmachinesteps`, ids: swp.wagmachinesteps});
          swp.shandoversteps = this.getWBObjects({ type: `${this.prefix}waghandoversteps`, ids: swp.waghandoversteps});
          // swp.sworkpackageimages = this.getWBObjects({ type: `${this.prefix}wagworkpackageimages`, ids: swp.wagworkpackageimages});
          swp.sworkpackageimages = [];

          delete swp.wagworksteps;
          delete swp.wagqualitysteps;
          delete swp.waglogisticsteps;
          delete swp.wagdefectsteps;
          delete swp.wagdesignsteps;
          delete swp.wagmaterialsteps;
          delete swp.smachinesteps;
          delete swp.waghandoversteps;
          delete swp.wagworkpackageimages;
          sworkpackages.push(swp);
        }
        return sworkpackages;
      },
      workbenchSearch(val){
        if (val && val !== '') {
          this.loadData(`&search=${val}`);
        }
        this.updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              search: val
            }
          })
      },
      loadData(url_suffix){
        return new Promise((resolve) => {
          this.updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              loading: true
            }
          });
          // if (['b', 'c'].includes(this.prefix) || this.isWBObjEmpty('sequences')) {
            this.requestWBObject({
              url: [
                {[`${this.prefix_wp_seletion}waggons`]: ''},
                {showWithEntitiesNormalized: ''}
              ],
              url_suffix: url_suffix
            }).then(() => {
              this.updateWBLObject({
                path: [
                  {workbench_variables: ''}
                ],
                update: {
                  loading: false
                }
              });
              resolve();
            });
          // }
        });
      }
    }
  }
</script>
<style>
  .token-view {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgb(106 106 106 / 80%);
    z-index: 2;
    cursor: pointer;
    font-weight: bold;
  }
</style>
